import Field from "@/components/Field";
import { isRequired } from "@/lib/form";
import ProjectRoleSelect from "@/modules/projects/components/ProjectRoleSelect";
import { useProjectSchedulesContext } from "@/modules/projects/components/schedules/ProjectSchedulesContext";
import { writeProjectSchedulesForm } from "@/schemas/projectSchedule";
import { memo } from "react";
import { useTranslation } from "react-i18next";

const projectRoleIdSchema =
  writeProjectSchedulesForm.innerType().shape.project_role_id;

const ProjectRoleFieldComponent = () => {
  const { t } = useTranslation();
  const { projectId } = useProjectSchedulesContext();

  return (
    <Field
      name="project_role_id"
      label={t("projectSchedules.fields.project_role_id")}
      required={isRequired(projectRoleIdSchema)}
      className="space-y-2"
      render={({ field }) => (
        <ProjectRoleSelect
          projectId={projectId}
          className="w-full border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
          inDialog
          loading="eager"
          {...field}
        />
      )}
    />
  );
};

export const ProjectRoleField = memo(ProjectRoleFieldComponent);
